(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["simmi-share-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-simmi-share-button]');
    if (!button) return;

    const component = button.closest('[data-simmi-share]');
    const title = component.dataset.shareTitle;
    const url = component.dataset.shareUrl;
    const label = component.querySelector('[data-simmi-share-label]');

    try {
      if (navigator.share) {
        await navigator.share({ title, url });
        return;
      }

      await navigator.clipboard.writeText(url);
      label.textContent = component.dataset.labelCopied;
      window.setTimeout(() => {
        label.textContent = component.dataset.labelDefault;
      }, 2200);
    } catch (error) {
      if (error.name !== 'AbortError') {
        window.location.href = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(url)}`;
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
